export default "dist/images/block-feature-basic.d95bb40.png";